import { GetTermPinCommand } from '../../../components/term_pin/commands/get_term_pin_command';
import { ToggleSectionPinsDialogCommand } from '../commands/toggle_section_pins_dialog_command';
import { RegistrationPinsPermissionQuery } from '../queries/registration_pins_permission_query';
import { CommunicatorService } from 'ui-ng-component-communicator';

export class RegistrationPinsPermissionFacade {
  constructor(
    private $stateParams: ng.ui.IStateParamsService,
    private ngRegistrationPinsPermissionQuery: RegistrationPinsPermissionQuery,
    private toggleSectionPinsDialogCommand: ToggleSectionPinsDialogCommand,
    private getTermPinCommand: GetTermPinCommand,
    private ngComponentCommunicatorService: CommunicatorService
  ) {}

  onEnterSectionPinsTriggerEnded() {
    this.toggleSectionPinsDialogCommand(true);
  }

  onEnterTermPinsTriggerEnded() {
    this.getTermPinCommand(this.$stateParams.termId).then(() => {
      this.ngComponentCommunicatorService.publish('OPEN_TERM_PIN_MODAL');
    });
  }
}

angular
  .module('capability-ng-scheduler')
  .service('ngRegistrationPinsPermissionFacade', RegistrationPinsPermissionFacade);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/views/registration/facades/registration_pins_permission_facade.ts